var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"label-cols":"4","label-align":"right"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"value":_vm.value,"state":_vm.valid,"size":"sm"},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }